// extracted by mini-css-extract-plugin
module.exports = {"confirmationModal":"confirmation-modal_confirmationModal__260m_","confirmationBackground":"confirmation-modal_confirmationBackground__1Zgsk"};